
document.addEventListener("DOMContentLoaded", function () {
  const OFFSET = 100;

  function smoothScrollToId(id) {
    const target = document.getElementById(id);
    if (!target) return;

    const y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      OFFSET;

    window.scrollTo({
      top: y,
      behavior: "smooth"
    });
  }

  /* Handle ALL anchor clicks */
  document.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener("click", function (e) {
      const url = new URL(this.href, window.location.origin);

      const isSamePage =
        url.pathname === window.location.pathname &&
        url.hash.length > 1;

      if (!isSamePage) return;  

      e.preventDefault();

      const id = url.hash.replace("#", "");

      document.body.classList.remove("nav-is-visible"); 
 
      document.body.classList.add("disable-hover");
      this.blur();

      history.pushState(null, "", url.hash);
      smoothScrollToId(id);
      setTimeout(() => {
        document.body.classList.remove("disable-hover");
      }, 600);
    });
  });

  if (window.location.hash) {
    const id = window.location.hash.replace("#", "");
    setTimeout(() => smoothScrollToId(id), 300);
  }
});



// humberger
// (function () {
//   var $container = $('.product-template__container');
//   if (!$container.length) return;

//   var shippingBlock = $container.find('.shipping-with-delivery');
//   if (!shippingBlock.length) return;

//   var outofstock = $container.find('.out-of-stock');

//   if (outofstock.length) {
//     console.log('show block');
//     shippingBlock.show();
//   } else {
//     console.log('hide block');
//     shippingBlock.hide();
//   }
// })();



